import { RtoasterParameter } from "../../../core/models/rtoaster/rtoaster_utils";


export const setParametersCallBack = (rtoasterParameter?: RtoasterParameter) => {
  if (rtoasterParameter) {
    if (rtoasterParameter.catalogItemCode) Rtoaster.item(rtoasterParameter.catalogItemCode);
  }
}
